import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import baseURL from "../component/baseURL";
import { useTranslation } from 'react-i18next';

export default function CatagoryDetails() {
    const { t } = useTranslation();
    const location = useLocation();
    const { partner_id, category } = location.state || {};
    const navigate = useNavigate();

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDetails = async () => {
            let formdata = new FormData();
            formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
            formdata.append("partner_id", partner_id);
            formdata.append("staff_accounts", category);

            try {
                const response = await fetch(baseURL.URL + "/consumer_end/partner_details", {
                    method: "POST",
                    body: formdata
                });
                const responseJson = await response.json();
                if (responseJson.server.code === 200) {
                    const responseData = responseJson.response[0];
                    // Ensure staff_accounts is always an array
                    if (!responseData.staff_accounts) {
                        responseData.staff_accounts = [];
                    }
                    // Validate staff_accounts data
                    if (Array.isArray(responseData.staff_accounts)) {
                        responseData.staff_accounts = responseData.staff_accounts.filter(staff =>
                            staff && staff.id && staff.fname && staff.email
                        ).map(staff => ({
                            ...staff,
                            fname: staff.fname || '',
                            lname: staff.lname || '',
                            email: staff.email || '',
                            phone: staff.phone || '',
                            status: staff.status || '0'
                        }));
                    }
                    setData(responseData);
                } else {
                    setData(null);
                    setError(responseJson.server.message || 'Failed to fetch data');
                }
            } catch (error) {
                setData(null);
                setError(error.message);
            }
        };

        if (partner_id) {
            fetchDetails();
        }
    }, [partner_id]);

    if (error) {
        return (
            <div className="catagory-wrapper">
                <div className="container">
                    <div className="catagory-details-holder">
                        <div className="text-center py-12">
                            <div className="text-red-600 text-4xl mb-4">⚠️</div>
                            <h3 className="text-red-600 text-lg font-medium mb-2">{t('error')}</h3>
                            <p className="text-red-500 mb-6">{error}</p>
                            <button
                                onClick={() => window.location.reload()}
                                className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium"
                                aria-label={t('retry')}
                            >
                                {t('retry')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!data) {
        return (
            <div className="catagory-wrapper">
                <div className="container">
                    <div className="catagory-details-holder">
                        <div className="text-center py-12">
                            <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-200 border-t-blue-600 mx-auto mb-4"></div>
                            <p className="text-gray-600 text-lg font-medium">{t('loading')}...</p>
                            <p className="text-gray-400 text-sm mt-2">{t('loadingDescription')}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="catagory-wrapper">
            <div className="container">
                <div className="catagory-details-holder">
                    <div className="catagory-details-holder-header flex items-center" data-aos="fade-down">
                        <figure>
                            <img
                                src={data.company_image == "" || null ? 'http://www.plannbuild.com/upload/user.jpg' : 'https://www.plannbuild.com/data_upload/frontendImage/companyImage/' + data.company_image}
                                alt={data.company_name}

                            />
                        </figure>
                        <div className="catagory-details-content-sec">
                            <div className="catagory-details-content-sec-title flex items-center" style={{ fontSize: 24, fontWeight: 600 }}>{data.company_name} <span className="catagory-details-content-sec-status" style={{
                                background: "#e6f4ea",
                                color: "#1A932E",
                                borderRadius: 50,
                                padding: "5px 15px",
                                fontSize: 14,
                                marginLeft: 12,
                                fontWeight: 400
                            }}>{data.status == 1 ? t('active') : t('inactive')}</span></div>

                            <div style={{ color: "#888", marginTop: 8 }}>
                                {t('specialties')} : {data.specialities == null ? 'N/A' : data.specialities}
                            </div>
                            {/* <div style={{ marginTop: 8 }}>
                                <span style={{ color: "#fbbc04", fontSize: 18 }}>
                                    {data.rating == null ? 'N/A' : ("★".repeat(data.rating) + "☆".repeat(5 - data.rating))}
                                </span>
                                <span style={{ color: "#444", marginLeft: 8 }}>
                                    ({data.reviews == null ? 'N/A' : data.reviews} Reviews)
                                </span>
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className="catagory-details-holder">

                    <div className="about-header flex justify-between items-center mb-4" data-aos="fade-down">
                        <div className="about-header-title text-left">{t('companyInformation')}</div>

                    </div>
                    <div className="about-content flex justify-between gap-4 md:flex-row sm:flex-col" data-aos="fade-down">
                        <div className="about-content-item">
                            <div className="about-content-item-title mb-4" >{t('email')}</div>
                            <div className="about-content-item-content" >{data.email == null ? 'N/A' : data.email}</div>
                        </div>
                        <div className="about-content-item">
                            <div className="about-content-item-title mb-4">{t('experience')}</div>
                            <div className="about-content-item-content">{data.experience == null ? 'N/A' : data.experience}</div>
                        </div>
                    </div>
                </div>

                <div className="catagory-details-holder" data-aos="fade-down">

                    <div className="about-header-title text-left">{t('website')}</div>
                    <div className="about-content-item-title mt-4 mb-4">{t('url')}</div>
                    <Link to={data.website} target="_blank" rel="noopener noreferrer" className="about-content-item-content-link">
                        {data.website}
                    </Link>
                </div>

                <div className="catagory-details-holder" data-aos="fade-down">

                    <div className="about-header flex justify-between items-center mb-4">
                        <div className="about-header-title text-left">{t('about')}</div>

                    </div>
                    <div className="about-content flex justify-between gap-4 md:flex-row sm:flex-col">
                        <div className="about-content-item w-full">
                            <div className="about-content-item-title mb-4" >{t('bio')}</div>
                            <div className="about-content-item-content html-content" dangerouslySetInnerHTML={{ __html: data.bio == null ? 'N/A' : data.bio }}></div>
                        </div>

                    </div>
                </div>

                {/* Staff Accounts Section */}
                {data && data.staff_accounts && (
                    <>

                        {
                            data.staff_accounts.length > 0 ? (
                                <div className="catagory-details-holder" data-aos="fade-down">
                                    <div className="about-header flex justify-between items-center mb-4">
                                        <div className="about-header-title text-left">List of {category}</div>
                                    </div>
                                    <div className="staff-accounts-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                        {data.staff_accounts.map((staff, index) => (
                                            <div key={staff.id} className="staff-card bg-white p-4 rounded-lg shadow-md border flex items-center" role="article" aria-label={`Staff member ${staff.fname} ${staff.lname}`}>
                                                <figure>
                                                    <img src={staff.profile_image || 'http://www.plannbuild.com/upload/user.jpg'} alt={staff.fname} />
                                                </figure>
                                                <div className="staff-info">
                                                    <div className="staff-name font-semibold text-lg mb-2">
                                                        {staff.fname} {staff.lname}
                                                    </div>
                                                    <div className="staff-details space-y-2 text-sm">
                                                        <div className="staff-desc">{staff.description == null ? 'N/A' : staff.description}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                null
                            )
                        }
                    </>
                )}


            </div>
        </div>
    );
}
